import { methods, request } from "./base";

const symptomsApis = {
  getSymptoms: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/patient_visit_symptoms/fetchPatientSymptoms",
      payload: data,
    }),
  getPSPSymptoms: async (data?: any, query_params?: any) =>
    await request({
      method: methods.GET,
      route: "/patient_visit_symptoms/fetch_psp_symptoms_questionnaire",
      payload: data,
      query_params,
    }),
};

export default symptomsApis;
